export const ACTIONS = {
  /**
   * POB
   */
  GET_POB_REPORT: "GET_POB_REPORT",

  /**
   * Heli
   */
  GET_HELI_REPORT: "GET_HELI_REPORT",
  DOWNLOAD_HELI_REPORT: "DOWNLOAD_HELI_REPORT",

  /**
   * Work Schedule
   */
  GET_WORK_SCHEDULE_REPORT: "GET_WORK_SCHEDULE_REPORT",
  UNLOAD_WORK_SCHEDULE_REPORT: "UNLOAD_WORK_SCHEDULE_REPORT",
  DOWNLOAD_WORK_SCHEDULE_REPORT: "DOWNLOAD_WORK_SCHEDULE_REPORT",

  /**
   * Shedule Overrides Report
   */
  GET_SCHEDULE_OVERRIDES_REPORT: "GET_SCHEDULE_OVERRIDES_REPORT",

  /**
   * Dashboard
   */
  GET_DASHBOARD_REPORT_STATS: "GET_DASHBOARD_REPORT_STATS",
  GET_WORK_SCHEDULE_OVERRIDE_TIMESERIES:
    "GET_WORK_SCHEDULE_OVERRIDE_TIMESERIES",
  GET_AVAILABLE_PERSONNEL_ONSHORE_BY_COUNTRY:
    "GET_AVAILABLE_PERSONNEL_ONSHORE_BY_COUNTRY",
  GET_PERSONNEL_ONSHORE_WITH_REQUIRED_TIMEOFF_BY_COUNTRY:
    "GET_PERSONNEL_ONSHORE_WITH_REQUIRED_TIMEOFF_BY_COUNTRY",
  GET_EMPLOYEES_BY_EMPLOYEE_TYPE_AND_CARD_CONTAINER_TYPE:
    "GET_EMPLOYEES_BY_EMPLOYEE_TYPE_AND_CARD_CONTAINER_TYPE",
};

export const HELI_REPORT_FORM = {
  ID: "heliReport",
  OFFSHORE_BOUND: "offshoreBound",
  SHORE_BOUND: "shoreBound",
  OFFSHORE_ID: "offshoreId",
  DISPLAY_NAME: "name",
  DATE: "date",
  CHECK_IN: "checkIn",
  DEPARTURE: "departure",
  RETURN_DATE: "returnDate",
  SHIFT_TYPE: "shiftType",
  HELIPORT: "heliport",
  SERVICE: "service",
  MAX_INDEX: "maxIndex",
};

export const WORK_SCHEDULE_REPORT_TYPE = {
  MONTH: 0,
  YEAR: 1,
};

export const WORK_SCHEDULE_REPORT_FORM = {
  ID: "workScheduleReport",
  TYPE: "reportType",
  START_DATE: "startDate",
  END_DATE: "endDate",
  NUMBER_OF_WEEKS: "numberOfWeeks",
  YEAR: "year",
  MONTH: "month",
  SEARCH: "search",
  EMPLOYEE_GROUP_ID: "employeeGroupId",
};
